<template>
  <i-modal class="fineart-confirm"
           width="595"
           :title="title"
           :value="isShowed"
           @on-visible-change="changeHandler">
    <section class="text-mid text-grey-666">
      <slot name="content"></slot>
    </section>
    <div slot="footer">
      <div class="l-flex-end l-flex-grow-1">
        <i-button type="text" class="cancel-button cursor-pointer" size="large" @click="cancelModel" v-if="isShowCancelButton">取消</i-button>
        <i-button type="primary" class="confirm-button cursor-pointer" size="large" @click="handleSubmit">{{confirmText}}</i-button>
      </div>
    </div>
  </i-modal>
</template>

<script>
import { Modal } from 'iview'

export default {
  name: 'FineartConfirm',
  data () {
    return {
      value: ''
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    isShowed: {
      type: Boolean,
      default: false
    },
    placeHolder: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    isShowCancelButton: {
      type: Boolean,
      default: true
    }
  },
  computed: {
  },
  model: {
    prop: 'isShowed',
    event: 'change-show'
  },
  methods: {
    cancelModel () {
      this.$emit('change-show', false) // 关闭弹窗
    },
    changeHandler (isShowed) {
      this.$emit('change-show', isShowed)
    },
    handleSubmit () {
      this.$emit('confirm', this.value) // 返回保存数据
    }
  },
  components: {
    'i-modal': Modal
  }
}
</script>

<style lang="stylus">
.fineart-confirm .ivu-modal-content .ivu-modal-body
  overflow: unset!important
  .icon-warn
    bg-icon(18px, 18px, '../assets/cloudstorage/icon-warn.png')
  .width-464
    width: 464px
</style>



// WEBPACK FOOTER //
// src/components/FineartConfirm.vue